// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__d067a1648b68fb2ca5e6","cls2":"SimplePaperPodcast-cls2__cd469351b722e2f9fc42 SimplePaperPodcast-cls1__d067a1648b68fb2ca5e6"};